export enum FailureReason {
  ConfigurationError = 'Integrations.FailureReason.ConfigurationError',
  GenericError = 'Integrations.FailureReason.GenericError',
  UnexpectedError = 'Integrations.FailureReason.UnexpectedError',
  ResourceError = 'Integrations.FailureReason.ResourceError',
  ExistingResourceFromOtherIntegration = 'Integrations.FailureReason.ExistingResourceFromOtherIntegration',
}
